import React from 'react';
import { Box } from '@mui/material';

const NotFound = () => {
    return (
        <Box sx={{backgroundColor: "#2b323c", textAlign: "center"}}>
            <img className="img-fluid" src="https://i.ibb.co/sCkNYtc/Error-404-1.png" alt="" />
        </Box>
    );
};

export default NotFound;